<template><!-- svgo-optimised -->
<svg class="icon icon__play" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 12 7 20.66V3.34L22 12Z"/></svg>
</template>